import React from "react";
import {
  Box,
  useMediaQuery,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  ListSubheader,
  Typography,
  TextField,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandMore from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";

const FilterComponent = ({ setFilter, posFilter, setPosFilter, fopFilter, setFopFilter,selectedFilters,setSelectedFilters, clearFilters, selectedTab }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  // const [selectedFilters, setSelectedFilters] = useState([]);

  // const { selectedFilter } = useSelector((state) => state.paymentCatalogue);

  // React.useEffect (() => {
  //   clearFilters();
  //   // if(selectedTab === 0) {
  //   //   setSelectedFilters([]);
  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedTab])

  const handleDropdownChange = (event) => {
    // event.preventDefault();
    setSelectedFilters(event.target.value);
    // setFilter(event.target.value);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "stretch" : "center",
        justifyContent: isMobile ? "center" : "space-between",
        flexWrap: isMobile ? "wrap" : "nowrap",
        gap: isMobile ? 2 : 0,
        marginBottom: 2,
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", gap: 3 }}>
          <FormControl
            sx={{ maxWidth: isMobile ? "100%" : "200px", minWidth: "200px" }}
          >
            <Select
              variant="standard"
              multiple
              value={selectedFilters}
              onChange={handleDropdownChange}
              displayEmpty
              renderValue={() => (
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                    lineHeight: "20px",
                  }}
                >
                  Filter
                </Typography>
              )}
              size="small"
              startAdornment={
                <FilterListIcon sx={{ marginRight: 1, color: "#1460AA" }} />
              }
              MenuProps={{
                PaperProps: {
                  sx: {
                    height: "450px",
                    overflowY: "auto",
                    "& .MuiMenuItem-root.Mui-selected": {
                      backgroundColor: "inherit",
                    },
                  },
                },
              }}
              sx={{
                "& .MuiSelect-icon": {
                  color: "#000000",
                },
                "&.MuiInput-underline:before": {
                  borderBottom: "1px solid #C9CACC",
                },
              }}
            >
              <ListSubheader
                sx={{
                  backgroundColor: "#F1F7FB",
                  position: "static",
                  mt: -1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#000000",
                  height: "56px",
                }}
              >
                <span>Last Modified</span>
                <ExpandMore />
              </ListSubheader>
              <MenuItem sx={{ p: 0 }} value="Created">
                <Checkbox
                  sx={{ color: "#1460AA" }}
                  checked={selectedFilters.indexOf("Created") > -1}
                />
                <ListItemText primary="Created" />
              </MenuItem>
              <MenuItem sx={{ p: 0 }} value="Modified">
                <Checkbox
                  sx={{ color: "#1460AA" }}
                  checked={selectedFilters.indexOf("Modified") > -1}
                />
                <ListItemText primary="Modified" />
              </MenuItem>

              <ListSubheader
                sx={{
                  backgroundColor: "#F1F7FB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#000000",
                  height: "56px",
                }}
              >
                <span>Seller Type</span>
                <ExpandMore />
              </ListSubheader>
              <MenuItem sx={{ p: 0 }} value="Agency">
                <Checkbox
                  sx={{ color: "#1460AA" }}
                  checked={selectedFilters.indexOf("Agency") > -1}
                />
                <ListItemText primary="Agency" />
              </MenuItem>
              <MenuItem sx={{ p: 0 }} value="Consumer">
                <Checkbox
                  sx={{ color: "#1460AA" }}
                  checked={selectedFilters.indexOf("Consumer") > -1}
                />
                <ListItemText primary="Consumer" />
              </MenuItem>

              <ListSubheader
                sx={{
                  backgroundColor: "#F1F7FB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#000000",
                  height: "56px",
                }}
              >
                <span>Cash</span>
                <ExpandMore />
              </ListSubheader>
              <MenuItem sx={{ p: 0 }} value="Enabled">
                <Checkbox
                  sx={{ color: "#1460AA" }}
                  checked={selectedFilters.indexOf("Enabled") > -1}
                />
                <ListItemText primary="Enabled" />
              </MenuItem>
              <MenuItem sx={{ p: 0 }} value="Disabled">
                <Checkbox
                  sx={{ color: "#1460AA" }}
                  checked={selectedFilters.indexOf("Disabled") > -1}
                />
                <ListItemText primary="Disabled" />
              </MenuItem>
            </Select>
          </FormControl>

          <TextField
            variant="standard"
            size="small"
            placeholder="POS"
            value={posFilter}
            onChange={(e) => setPosFilter(e.target.value)}
            InputProps={{
              startAdornment: (
                <SearchIcon
                  sx={{
                    mr: 1,
                    width: "19.7px",
                    height: "19.7px",
                    color: "#1460AA",
                  }}
                />
              ),
              sx: {
                "& input::placeholder": {
                  color: "#000000",
                  fontWeight: 600,
                  fontFamily: "Open Sans",
                  opacity: 1,
                },
                "&.MuiInput-underline:before": {
                  borderBottom: "1px solid #C9CACC",
                },
              },
            }}
          ></TextField>

          <TextField
            variant="standard"
            size="small"
            placeholder="FOP"
            value={fopFilter}
            onChange={(e) => setFopFilter(e.target.value)}
            InputProps={{
              startAdornment: (
                <SearchIcon
                  sx={{
                    mr: 1,
                    width: "19.7px",
                    height: "19.7px",
                    color: "#1460AA",
                  }}
                />
              ),
              sx: {
                "& input::placeholder": {
                  color: "#000000",
                  fontWeight: 600,
                  fontFamily: "Open Sans",
                  opacity: 1,
                },
                "&.MuiInput-underline:before": {
                  borderBottom: "1px solid #C9CACC",
                },
              },
            }}
          ></TextField>
        </Box>
      </Box>
    </Box>
  );
};

export default FilterComponent;